<!-- switch search type both in menu and page header -->
<ion-item lines="full" class="fullWidth" [attr.data-intro]="'help.search.switchSearchStyle'|translate">
    <ion-segment [(ngModel)]="searchType" (ionChange)="updateSimple()">
        <ion-segment-button value="simple" class="no-text-transform">
            {{ 'search.simple' | translate }}
        </ion-segment-button>
        <ion-segment-button value="complex" class="no-text-transform">
            {{ 'search.complex' | translate }}
        </ion-segment-button>
    </ion-segment>
</ion-item>

<!--complex search in menu-->
<div *ngIf="splitPaneVisible && !searchData.simple && !inSettings"
     [attr.data-intro]="'help.search.searchCombine'|translate">
    <ion-item lines="inset" [attr.data-intro]="'help.search.complexDeviceSearch'|translate">
        <app-text-search-complex translationPrefix="search.free"
                                 [(stringSearch)]="searchData.freeSearch"
                                 (stringSearchChange)="reportSearchData()">
        </app-text-search-complex>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.category'|translate">
        <app-category-select [canUsePartial]="true"
                             labelPosition="stacked"
                             [(selectedCategory)]="searchData.category"
                             (selectedCategoryChange)="reportSearchData()">
        </app-category-select>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.department'|translate">
        <app-department-select [multiple]="true"
                               labelPosition="stacked"
                               [(selectedItems)]="searchData.department"
                               (selectedItemsChange)="reportSearchData()">
        </app-department-select>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.deviceStatus'|translate">
        <app-device-status-select [multiple]="true"
                                  labelPosition="stacked"
                                  [(selectedItems)]="searchData.deviceStatus"
                                  (selectedItemsChange)="reportSearchData()">
        </app-device-status-select>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.locationStatus'|translate">
        <app-location-status-select [multiple]="true"
                                    labelPosition="stacked"
                                    [(selectedItems)]="searchData.locationStatus"
                                    (selectedItemsChange)="reportSearchData()">
        </app-location-status-select>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.location'|translate">
        <app-text-search-complex translationPrefix="search.location"
                                 [(stringSearch)]="searchData.location"
                                 (stringSearchChange)="reportSearchData()">
        </app-text-search-complex>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.date'|translate">
        <app-date-input translationPrefix="search.date"
                        [singleDate]=false
                        [(date)]="searchData.date"
                        (dateChange)="reportSearchData()">
        </app-date-input>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.ownership'|translate">
        <app-ownership-select [multiple]="true"
                              labelPosition="stacked"
                              [(selectedItems)]="searchData.ownership"
                              (selectedItemsChange)="reportSearchData()">
        </app-ownership-select>
    </ion-item>
    <ion-item lines="inset" [attr.data-intro]="'help.search.sort'|translate">
        <app-sort-select [(sortData)]="searchData.sort"
                         labelPosition="stacked"
                         (sortDataChange)="reportSearchData()">
        </app-sort-select>
    </ion-item>
</div>

<!--simple search in menu-->
<div *ngIf="splitPaneVisible && searchData.simple && !inSettings"
     [attr.data-intro]="'help.search.searchCombine'|translate">
    <ion-item lines="inset"
              [attr.data-intro]="'help.search.simpleSearch'|translate">
        <app-text-search-simple translationPrefix="search.free_simple"
                                [(stringSearch)]="searchData.simpleSearch"
                                (stringSearchChange)="reportSearchData()">
        </app-text-search-simple>
    </ion-item>
    <ion-item detail="false"
              [attr.data-intro]="'help.search.simpleUsable'|translate">
        <ion-label (click)="searchData.onlyUsable = !searchData.onlyUsable">
            {{'search.only_usable' | translate}}
        </ion-label>
        <ion-toggle [(ngModel)]="searchData.onlyUsable" (ionChange)="reportSearchData()"></ion-toggle>
    </ion-item>
    <ion-item *ngIf="userDepartment" detail="false"
              [attr.data-intro]="'help.search.simpleDepartment'|translate">
        <ion-label (click)="searchData.onlyDepartment = !searchData.onlyDepartment">
            {{'search.own_department' | translate}} {{ userDepartment }}
        </ion-label>
        <ion-toggle [(ngModel)]="searchData.onlyDepartment" (ionChange)="reportSearchData()"></ion-toggle>
    </ion-item>
    <app-simple-sort-select [(sortData)]="searchData.simpleSort"
                            (sortDataChange)="reportSearchData()"
                            [attr.data-intro]="'help.search.sort'|translate">
    </app-simple-sort-select>
</div>

<!--complex search in page header-->
<div *ngIf="(!splitPaneVisible || inSettings ) && !searchData.simple"
     [attr.data-intro]="'help.search.searchCombine'|translate">
    <ion-item lines="inset">
        <div class="inline sixty"
             [attr.data-intro]="'help.search.complexDeviceSearch'|translate">
            <app-text-search-complex translationPrefix="search.free"
                                     [(stringSearch)]="searchData.freeSearch"
                                     (stringSearchChange)="reportSearchData()">
            </app-text-search-complex>
        </div>
        <div class="inline fourty" [attr.data-intro]="'help.search.location'|translate">
            <ion-item lines="inset">
                <app-text-search-complex translationPrefix="search.location"
                                         [(stringSearch)]="searchData.location"
                                         (stringSearchChange)="reportSearchData()">
                </app-text-search-complex>
            </ion-item>
        </div>
    </ion-item>
    <ion-item lines="inset">
        <div class="inline sixty" [attr.data-intro]="'help.search.category'|translate">
            <app-category-select [canUsePartial]="true"
                                 labelPosition="stacked"
                                 [(selectedCategory)]="searchData.category"
                                 (selectedCategoryChange)="reportSearchData()">
            </app-category-select>
        </div>
        <div class="inline fourty" [attr.data-intro]="'help.search.ownership'|translate">
            <app-ownership-select [multiple]="true"
                                  labelPosition="stacked"
                                  [(selectedItems)]="searchData.ownership"
                                  (selectedItemsChange)="reportSearchData()">
            </app-ownership-select>
        </div>
    </ion-item>
    <ion-item lines="inset">
        <div class="inline third" [attr.data-intro]="'help.search.department'|translate">
            <app-department-select [multiple]="true"
                                   labelPosition="stacked"
                                   [(selectedItems)]="searchData.department"
                                   (selectedItemsChange)="reportSearchData()">
            </app-department-select>
        </div>
        <div class="inline third" [attr.data-intro]="'help.search.deviceStatus'|translate">
            <app-device-status-select [multiple]="true"
                                      labelPosition="stacked"
                                      [(selectedItems)]="searchData.deviceStatus"
                                      (selectedItemsChange)="reportSearchData()">
            </app-device-status-select>
        </div>
        <div class="inline third" [attr.data-intro]="'help.search.locationStatus'|translate">
            <app-location-status-select [multiple]="true"
                                        [(selectedItems)]="searchData.locationStatus"
                                        (selectedItemsChange)="reportSearchData()">
            </app-location-status-select>
        </div>

    </ion-item>
    <ion-item lines="inset">
        <div class="inline sixty" [attr.data-intro]="'help.search.sort'|translate">
            <app-sort-select [(sortData)]="searchData.sort"
                             labelPosition="stacked"
                             (sortDataChange)="reportSearchData()">

            </app-sort-select>
        </div>
        <div class="inline fourty" [attr.data-intro]="'help.search.date'|translate">
            <app-date-input translationPrefix="search.date"
                            [singleDate]=false
                            [(date)]="searchData.date"
                            (dateChange)="reportSearchData()">
            </app-date-input>
        </div>
    </ion-item>

</div>

<!--simple search in page header-->
<div *ngIf="(!splitPaneVisible || inSettings) && searchData.simple"
     [attr.data-intro]="'help.search.searchCombine'|translate">
    <ion-item lines="inset"
              [attr.data-intro]="'help.search.simpleSearch'|translate">
        <app-text-search-simple translationPrefix="search.free_simple"
                                [(stringSearch)]="searchData.simpleSearch"
                                (stringSearchChange)="reportSearchData()">
        </app-text-search-simple>
    </ion-item>
    <ion-item lines="inset">
        <ion-toggle [(ngModel)]="searchData.onlyUsable" (ionChange)="reportSearchData()"></ion-toggle>
        <ion-label (click)="searchData.onlyUsable = !searchData.onlyUsable"
                   [attr.data-intro]="'help.search.simpleUsable'|translate">
            {{'search.only_usable' | translate}}
        </ion-label>
        <ion-toggle *ngIf="userDepartment" [(ngModel)]="searchData.onlyDepartment"
                    (ionChange)="reportSearchData()"></ion-toggle>
        <ion-label *ngIf="userDepartment" (click)="searchData.onlyDepartment = !searchData.onlyDepartment"
                   [attr.data-intro]="'help.search.simpleDepartment'|translate">
            {{'search.own_department' | translate}} {{ userDepartment }}
        </ion-label>
    </ion-item>
    <app-simple-sort-select [(sortData)]="searchData.simpleSort" [wide]="true"
                            (sortDataChange)="reportSearchData()"
                            [attr.data-intro]="'help.search.sort'|translate">
    </app-simple-sort-select>
</div>

<!-- reset both in menu and page header -->
<ion-item lines="full" class="fullWidth">
    <ion-button [ngClass]="{'half':!splitPaneVisible}" fill="clear" color="medium" (click)="clearSearchData()"
                [attr.data-intro]="'help.search.clear'|translate">
        <ion-icon name="close"></ion-icon>&nbsp;
        <ion-label class="preLineWhitespace" innerHTML="{{ 'search.clear' | translate }}"></ion-label>
    </ion-button>
    <ion-button [ngClass]="{'half':!splitPaneVisible}" fill="clear" color="medium" (click)="resetSearchData()"
                [attr.data-intro]="'help.search.reset'|translate">
        <ion-icon name="refresh"></ion-icon>&nbsp;
        <ion-label class="preLineWhitespace" innerHTML="{{ 'search.reset' | translate }}"></ion-label>
    </ion-button>
</ion-item>

<!-- export both in menu and page header -->
<ion-item lines="full" class="fullWidth" *ngIf="!inSettings && showExport"
          [attr.data-intro]="'help.search.export'|translate">
    <ion-button fill="clear" color="medium" (click)="exportData()">
        <ion-icon name="download"></ion-icon>&nbsp;
        <ion-label class="preLineWhitespace" innerHTML="{{ 'search.export' | translate }}"></ion-label>
    </ion-button>
    <ion-spinner *ngIf="exportBusy" name="lines" color="primary"></ion-spinner>
    <span *ngIf="showExportWarning"><ion-icon name="warning"></ion-icon>
        {{ 'search.export_warning' | translate }}</span>
    <span *ngIf="exportError" class="error">{{ exportError }}</span>
</ion-item>
